import React, { useMemo } from 'react';
import useLinkProps from '../../hooks/useLinkProps2';
import useLinkButtonStyles from './useLinkButtonStyles';
import useLocalization from 'localization';
import useInnerStyles from './useInnerStyles';
import handleStickyFocus from '../../utils/handleStickyFocus';
const withLinkButton = (Component) => React.forwardRef((props, ref) => {
    const { tabIndex, to, children, size = 'regular', variant = 'primary', width = 'natural', noDefaultMargin = false, id, onClick, styles, source, target, className } = props;
    const { t } = useLocalization();
    const { isHovered, isFocused, ...rest } = useLinkProps(to, children, variant);
    const handleClick = handleStickyFocus(rest.onBlur, onClick);
    const style = useLinkButtonStyles({
        size,
        width,
        variant,
        noDefaultMargin,
        isFocused,
        isHovered,
        styles
    });
    const innerStyles = useInnerStyles(isFocused || isHovered);
    const translatedChild = typeof children === 'string' ? t(String(children)) : children;
    const child = useMemo(() => variant === 'secondary' ? (React.createElement("span", { style: innerStyles }, translatedChild)) : (translatedChild), [variant, innerStyles, translatedChild]);
    const ariaAttributes = Object.entries(props)
        .filter(([key]) => key.startsWith('aria-'))
        .reduce((current, [nextKey, nextValue]) => ({
        ...current,
        ...{ [nextKey]: nextValue }
    }), {});
    const processedProps = useMemo(() => ({
        onClick: handleClick,
        id,
        style,
        source,
        className,
        ...rest,
        tabIndex,
        ...ariaAttributes,
        children: child,
        ...(target ? { target } : {})
    }), [
        handleClick,
        id,
        style,
        source,
        className,
        rest,
        tabIndex,
        ariaAttributes,
        child,
        target
    ]);
    return 'to' in processedProps ? (React.createElement(Component, { ...processedProps, ref: ref })) : (React.createElement("a", { ...processedProps }, processedProps.children));
});
export default withLinkButton;
//# sourceMappingURL=withLinkButton.js.map